import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';
import styled from 'react-emotion';
import i18next from 'i18next';
import { Container } from 'semantic-ui-react';

import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';
import ItemsCardsSlider from '~/modules/ecommerceCoreUI/components/basic/ItemsCardsSlider';
import { LinearLayout } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import Variant from '~/modules/ecommerceCoreUI/containers/Variant';

const BestSellerContainer = styled(LinearLayout)`
  .slick-slider {
    margin: 0 !important;
  }
`;

const BestSeller = ({
  queryResult,
  vendorID,
  vendorName,
}) => {
  const MIN_LENGTH_OF_BEST_SELLER = 0;
  return (
    <BestSellerContainer leftAligned>
      {queryResult
        && queryResult.best_seller.length > MIN_LENGTH_OF_BEST_SELLER && (
          <React.Fragment>
            <Spacer size={2} />
            <Container>
              <Label primary semiBold xxl>
                {i18next.t('eCommerceShops:ShopDetails.bestSellerTitle')}
              </Label>
            </Container>
            <Spacer size={1.5} />
            <ItemsCardsSlider>
              {queryResult.best_seller.map(product => (
                <Variant
                  isVertical
                  variantInfo={product}
                  key={product.ref_id}
                  isVendorProduct
                  variantVendorInfo={{ vendorID, vendorName }}
                />
              ))}
            </ItemsCardsSlider>
            <Spacer />
            <Separator customColorTone="#f9f9f9" separatorLength="full" separatorWeight={1.5} spacerSize={[1.5, 1.5, 2.5]} />
          </React.Fragment>
      )}
    </BestSellerContainer>
  );
};

BestSeller.propTypes = {
  queryResult: PropTypes.shape({}),
  vendorID: PropTypes.string.isRequired,
  vendorName: PropTypes.string.isRequired,
};

BestSeller.defaultProps = {
  queryResult: null,
};

export default withRootQuery(
  BestSeller,
  graphql`
    query BestSellerQuery($input: BestSellerInput) {
      best_seller(input: $input) {
        ...VariantData_variantInfo @relay(mask: false)
      }
    }
  `,
  null,
  props => ({
    input: {
      vendor_id: parseInt(props.vendorID, 10),
      page: {
        offset: 0,
        limit: 20,
      },
    },
  }),
);
